/**
 * Node Modules
 */
import React, { useState, useEffect } from 'react'

/**
 * Application Modules
 */
import './style.css'
import Section from '../../../components/section'

/**
 * Component
 */

export default function OurOffice({ hed, dek }) {
  const [index, setIndex] = useState(0)
  let timer
  const maxIndex = 6

  useEffect(() => {
    timer = setInterval(() => setIndex((index + 1) % (maxIndex + 1)), 4000)
    return () => clearInterval(timer)
  }, [index])

  return (
    <Section className="our-office" id="our-office">
      <div className="our-office__grid grid">
        <h2 className="our-office__hed column-start-1 column-end-6 column-start-2--t column-end-11--t column-start-3--d column-end-10--d">
          {hed}
        </h2>
        <p className="our-office__dek column-start-1 column-end-6 column-start-2--t column-end-11--t column-start-3--d column-end-10--d">
          {dek}
        </p>
      </div>

      <div className="office-carousel">
        <div className="office-carousel__carousel-group team-quote__carousel-group flex flex-center">
          <div
            onClick={() => setIndex(0)}
            className={`team-quote__carousel-dot ${index === 0 ? 'active' : ''}`}
          />
          <div
            onClick={() => setIndex(1)}
            className={`team-quote__carousel-dot ${index === 1 ? 'active' : ''}`}
          />
          <div
            onClick={() => setIndex(2)}
            className={`team-quote__carousel-dot ${index === 2 ? 'active' : ''}`}
          />
          <div
            onClick={() => setIndex(3)}
            className={`team-quote__carousel-dot ${index === 3 ? 'active' : ''}`}
          />
          <div
            onClick={() => setIndex(4)}
            className={`team-quote__carousel-dot ${index === 4 ? 'active' : ''}`}
          />
          <div
            onClick={() => setIndex(5)}
            className={`team-quote__carousel-dot ${index === 5 ? 'active' : ''}`}
          />
          <div
            onClick={() => setIndex(6)}
            className={`team-quote__carousel-dot ${index === 6 ? 'active' : ''}`}
          />
        </div>

        <div className="office-carousel__slide-group">
          <div className={`office-carousel__slide ${0 === index ? 'active' : ''}`}>
            <img className="office-carousel__image" src="/life-at-kinzoo/photo1.jpg" alt="Sean in a meeting and Blair working" />
          </div>
          <div className={`office-carousel__slide ${1 === index ? 'active' : ''}`}>
            <img className="office-carousel__image" src="/1-library.jpg" alt="The company library" />
          </div>
          <div className={`office-carousel__slide ${2 === index ? 'active' : ''}`}>
            <img className="office-carousel__image" src="/life-at-kinzoo/photo2.jpg" alt="Photo from a team all hands meeting" />
          </div>
          <div className={`office-carousel__slide ${3 === index ? 'active' : ''}`}>
            <img className="office-carousel__image" src="/2-docks.jpg" alt="North Shore Mountains " />
          </div>
          <div className={`office-carousel__slide ${4 === index ? 'active' : ''}`}>
            <img className="office-carousel__image" src="/life-at-kinzoo/photo3.jpg" alt="Photo of Joyce presenting during an all hands meeting" />
          </div>
          <div className={`office-carousel__slide ${5 === index ? 'active' : ''}`}>
            <img className="office-carousel__image" src="/3-office.jpg" alt="Office Images" />
          </div>
          <div className={`office-carousel__slide ${6 === index ? 'active' : ''}`}>
            <img className="office-carousel__image" src="/life-at-kinzoo/photo4.jpg" alt="Developers discussing databases" />
          </div>
        </div>
      </div>
    </Section>
  )
}
